import update from 'immutability-helper';

export default function setEventActivityData(state, action) {
  // console.log('SET_EVENT_ACTIVITY_DATA', action)

  return update(state, {
    eventActivity: {
      $set: action.data.event_counts,
    },
    eventStart: {
      $set: action.data.from,
    },
    eventEnd: {
      $set: action.data.to,
    },
    boundingRectangle: {
      left: {
        $set: action.data.left,
      },
      right: {
        $set: action.data.right,
      },
      top: {
        $set: action.data.top,
      },
      bottom: {
        $set: action.data.bottom,
      },
    },
    gettingChart: {
      $set: false,
    },
    renderChart: {
      $set: true,
    },
  });
}
